import React, { FunctionComponent } from "react"
import PureImage from "../../components/Image/PureImage"
import { iExhibition } from "../../definitions/Exhibition"
import { eImageVersions } from "../../definitions/Image"
import { useImage } from "../../hooks/useImage"
import { useImageUrl } from "../../hooks/useImageUrl"
import s from "./Exhibitions.less"

const Item: FunctionComponent<iExhibition & { useDefaultImage?: boolean }> = ({
  title,
  subtitle,
  fileVersions,
  posterImageId,
  useDefaultImage = false,
}) => {
  let url = ""
  if (useDefaultImage) {
    const { file } = useImage({
      fileId: posterImageId,
      fileCollection: "Files_ExhibitionPosters",
    })
    url = useImageUrl(eImageVersions.LIcon, file?.versions)
  } else {
    url = useImageUrl(eImageVersions.LIcon, fileVersions)
  }
  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage className={s.image} src={url} />
      </div>
      <div className="content-block">
        <h3>{title}</h3>
        <span>{subtitle}</span>
      </div>
    </div>
  )
}

export default Item
